'use client';

import React from 'react';
import { Button } from "@/app/components/ui/button"
import { useRouter } from 'next/navigation';
import Link from 'next/link';

interface PrivacyProps {
  onClose?: () => void;
}

export default function Privacy({ onClose }: PrivacyProps) {
  const router = useRouter();
  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      router.back();
    }
  };

  return (
    <div className="min-h-screen bg-white pt-20">
      {/* Header with close button */}
      <div className="bg-[#3D669D] py-4 px-4">
        <div className="max-w-4xl mx-auto flex justify-between items-center">
          <h1 className="text-2xl font-bold text-white">Privacy Policy</h1>
          <Button
            onClick={handleClose}
            size="sm"
            className="bg-white text-[#3D669D] hover:bg-gray-100 font-semibold"
          >
            Close
          </Button>
        </div>
      </div>
      
      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="space-y-6">
          <section className="bg-white border border-gray-200 p-6 rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Information Collection</h2>
            <p className="text-gray-700 leading-relaxed">
              We collect information that you provide directly to us, including contact information and any other information you choose to provide.
            </p>
          </section>

          <section className="bg-white border border-gray-200 p-6 rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Use of Information</h2>
            <p className="text-gray-700 leading-relaxed">
              We use the information we collect to provide, maintain, and improve our services, communicate with you, and comply with legal obligations.
            </p>
          </section>

          <section className="bg-white border border-gray-200 p-6 rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Information Sharing</h2>
            <p className="text-gray-700 leading-relaxed">
              We do not share your personal information with third parties except as described in this policy or with your consent.
            </p>
          </section>

          <section className="bg-white border border-gray-200 p-6 rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Data Security</h2>
            <p className="text-gray-700 leading-relaxed">
              We implement appropriate security measures to protect your personal information from unauthorized access, alteration, or destruction.
            </p>
          </section>

          <section className="bg-white border border-gray-200 p-6 rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Cookies</h2>
            <p className="text-gray-700 leading-relaxed">
              We use cookies and similar tracking technologies to track activity on our Service and hold certain information for analytics purposes.
            </p>
          </section>

          <section className="bg-white border border-gray-200 p-6 rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Your Rights</h2>
            <p className="text-gray-700 leading-relaxed">
              You have the right to access, update, or delete your personal information. Contact us to exercise these rights.
            </p>
          </section>

          <section className="bg-white border border-gray-200 p-6 rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Changes to Policy</h2>
            <p className="text-gray-700 leading-relaxed">
              We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page.
            </p>
          </section>
        </div>
        
        {/* Footer with back link */}
        <div className="mt-8 pt-6 border-t border-gray-200 text-center">
          <Link 
            href="/" 
            className="text-[#3D669D] hover:text-blue-700 font-semibold"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
} 